import React from "react";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import Contact from "./Contact";
import WhatsAppButton from "../components/WhatsAppButton";
import About from "./About";
import { Helmet } from "react-helmet";

function Home() {
  return (
    <>
      <Helmet>
        <title>Kavipriya Associates | Trusted Experts in Tax, GST, DGFT & Compliance</title>
        <meta
          name="description"
          content="Kavipriya Associates, based in Coimbatore, offers expert tax, GST, DGFT, customs, insurance, and statutory compliance services to Startups, MSMEs & Corporates across India."
        />
        <meta
          name="keywords"
          content="Kavipriya Associates, Tax Consultant Coimbatore, GST Filing, Income Tax Return, Book Keeping, DGFT License, Customs Clearance, MOOWR, MSME Subsidy, Financial Services, Compliance Consultant India"
        />
        <meta name="author" content="Kavipriya Associates" />
        <link rel="canonical" href="https://kavipriyaassociates.com/" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Kavipriya Associates | Tax, GST, Customs, Compliance Services in India" />
        <meta
          property="og:description"
          content="Reliable financial and statutory consulting for Startups, MSMEs & Corporates. Based in Coimbatore, serving PAN India."
        />
        <meta property="og:image" content="https://kavipriyaassociates.com/Logo.png" />
        <meta property="og:url" content="https://kavipriyaassociates.com/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Kavipriya Associates | Trusted Finance & Compliance Partner" />
        <meta
          name="twitter:description"
          content="Get expert help with GST, Income Tax, DGFT, Customs & more. Trusted by clients across India."
        />
        <meta name="twitter:image" content="https://kavipriyaassociates.com/Logo.png" />
        <meta name="twitter:card" content="summary_large_image" />

        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Kavipriya Associates",
      "url": "https://kavipriyaassociates.com",
      "logo": "https://kavipriyaassociates.com/logo.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9876543210",
        "contactType": "customer service",
        "areaServed": "IN",
        "availableLanguage": "English"
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Coimbatore",
        "addressRegion": "Tamil Nadu",
        "addressCountry": "India"
      },
      "sameAs": [
        "https://www.facebook.com/YOURPAGE",
        "https://www.linkedin.com/company/YOURPAGE"
      ]
    }
    `}
        </script>
      </Helmet>


      <HeroSection />
      <About />
      <ServicesSection />
      <Contact />
      <WhatsAppButton />
    </>
  );
}

export default Home;
